import folk from "./Assets/Images/folk_m.jpg";
import regional from "./Assets/Images/regional_m.jpg";
import sufi from "./Assets/Images/sufi_m.jpg";
import pop from "./Assets/Images/pop_m.jpg";

export const musicContentData = [
  {
    heading: "1. Folk / Classical Music",
    detail:
      "The devotional form of music most commonly founded in the Sufi Culture in South Asia. Sufi Music originated from the inspirational work of Sufi Poets like Rumi, Bulleh Shah and others. Distinct musical styles, singing and ceremonies have emerged over time, often unique to the local culture, but all unified under the purpose of creating this altered state of spiritual awareness.",
    img: folk,
  },
  {
    heading: "2. Regional Music",
    detail:
      "Regional Music in Pakistan gives a huge diversity to music and traditions of different regions in Pakistan as all regions have variety of people and tribes talk in many different languages. Famous singers include Alam Lohar form Punjab, Allan Fakir form Sindh, Zarsanga from Khyber Pakhtunkhwa, Akhtar Chanal Zahri form Balochistan and Shahid Akhtar Qalandar form Hunza, GB.",
    img: regional,
  },
  {
    heading: "3. Sufism",
    detail:
      "Sufism has an exceptional official rule as one of the most important genres of music in Pakistan. The purpose is get the artist and audience closer to Allah by repeating the trance-like words. It has many forms like Qawwali, Ghazal etc. perfomed by various artists in Pakistan i.e. Ustad Nusrat Fateh Ali Khan, Abida Parveen and Shazia Khushk and others.",
    img: sufi,
  },
  {
    heading: "4. Popular Music",
    detail:
      "Pakistani pop is a mixture of traditional Pakistani classical music and western influences of jazz, rock and roll, hip hop and disco sung in various languages of Pakistan, including Urdu. Pakistani pop musicians like Ahamed Rushdi, Nazia Hassan & Zeb Hassan, Atif Aslam and others have achieved an influential following and popularity in neighboring countries.",
    img: pop,
  },
];
